import { 
    API_URL_ENV, 
} from '../env';

export const API_URL = `${API_URL_ENV}/ads/ad-inventory`;
export const API_PAYMENTS_URL = `${API_URL_ENV}/ads/ad-payments`;
export const API_AUTH_URL = `${API_URL_ENV}/ads/ad-auth`;

export const KEYWORD_DIMENSION_FIELDS = {
    "DATE": true,
    "CAMPAIGN_NAME": true,
    "CAMPAIGN_TYPE": true,
    "AD_GROUP_NAME": true,
    "TARGETING_VALUE": true,
    "MATCH_TYPE": true,
    "CAMPAIGN_CLASS": true,
}
export const PRODUCT_DIMENSION_FIELDS = {
    "DATE": true,
    "CAMPAIGN_NAME": true,
    "CAMPAIGN_TYPE": true,
    "AD_GROUP_NAME": true,
    "PRODUCT_NAME": true,
    "CAMPAIGN_CLASS": true,
}
export const ADV_METRIC_FIELDS = {
    "IMPRESSIONS": true,
    "CLICKS": true,
    "AD_SPEND": true,
    "TOTAL_ORDERS_COUNT": true,
    "TOTAL_ORDERS_VALUE": true,
    "TOTAL_UNITS_SOLD": true,
    // "PDP_COUNT": true,
    // "ADD_TO_CART": true,
}
export const STATES = {
    STATE1: "Running",
    STATE2: "Paused",
    STATE3: "Archived",
    STATE4: "Daily Limit Reached",
    STATE5: "Total Limit Reached",
    STATE6: "Scheduled Paused",
    STATE7: "Expired",
    STATE8: "Daily Budget Limit Reached",
    STATE9: "Total Budget Limit Reached",
}

export const MENU = [
    {
        id: 'userManagement',
        name: 'User Management',
        roles: ['SUPERADMIN', 'OPS']
    },
    {
        id: 'onboarding',
        name: 'Onboarding',
        roles: ['SUPERADMIN', 'OPS']
    },
    {
        id: 'approval',
        name: 'Approval',
        roles: ['SUPERADMIN']
    },
    {
        id: 'requestApproval',
        name: 'Delink Approval',
        roles: ['SUPERADMIN']
    },
    {
        id: 'requestApproval',
        name: 'Link Approval',
        roles: ['BRAND','SELLER']
    },
    {
        id: 'link',
        name: 'Link Request',
        roles: ['AGENCY']
    },
    {
        id: 'delink',
        name: 'Delink Request',
        roles: ['AGENCY', 'BRAND', 'SELLER']
    },
    {
        id: 'campaigns',
        name: 'Campaign',
        roles: ['SUPERADMIN', 'OPS', 'AGENCY', 'BRAND', 'SELLER']
    },
    {
        id: 'analytics',
        name: 'Analytics',
        roles: ['SUPERADMIN', 'OPS', 'AGENCY', 'BRAND', 'SELLER']
    },
    {
        id: 'billing',
        name: 'Payment',
        roles: ['SUPERADMIN']
    }
];

export const ROLES = ['Super Admin', 'Admin', 'Seller', 'Brand', 'Agency'];

export const roleTypes = {
    'SUPERADMIN': 'Super admin',
    'OPS': 'Admin',
    'SELLER': 'Seller',
    'BRAND': 'Brand',
    'AGENCY': 'Agency'
}